import { render } from "./StockCard.vue?vue&type=template&id=5de94e4e&scoped=true"
import script from "./StockCard.vue?vue&type=script&lang=js"
export * from "./StockCard.vue?vue&type=script&lang=js"

import "./StockCard.vue?vue&type=style&index=0&id=5de94e4e&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de94e4e"]])

export default __exports__